import { formatCurrency } from './currency';

export function formatPrice(price?: number) {
  if (price == null) return "-";
  return formatCurrency(price);
}

export function formatType(type?: string) {
  if (!type) return "-";
  return type.replace(/_/g, " ");
}

export function formatDate(date?: string) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("nl-NL", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function statusSeverity(status?: string) {
  return status === "active" ? "success" : "warn";
}
